import React from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from '../../contexts/LanguageContext';
import { translations } from '../../translations/translations';
import amostra from "../../assets/CasassectionPhoto.jpg";
import fotodascasastodasquinta from "../../assets/fotodascasastodasquinta.jpg";
import salaaosol from "../../assets/salaaosol.jpg";
import { ArrowRight } from "lucide-react";
import { preloadVillaDetail } from "../../utils/routePreload";
import "./Casas.css";

function Casas() {
    const navigate = useNavigate();
    const { language } = useLanguage();
    const t = translations?.[language] || translations?.pt || {};

    const handleExplore = () => {
        navigate("/villa/villa-sao-sebastiao");
    };

    return (
        <section className="casas-section">
            {/* CENTERED HEADER: Title + Description */}
            <div className="casas-header">
                <p className="casas-subtitle">{t.casas.subtitle}</p>
                <h2 className="casas-title">{t.casas.title}</h2>
                <p className="casas-description">
                    {t.casas.description}
                </p>
            </div>

            {/* TWO-COLUMN LAYOUT */}
            <div className="casas-content-wrapper">
                {/* Mobile image shown between description and left text */}
                <div className="casas-header-image">
                    <img src={salaaosol} alt="Villas overview" loading="lazy" />
                </div>
                <div className="casas-left-section">
                    <div className="casas-left-text">
                        <p>
                            {t.casas.leftText1}
                        </p>
                        <p>
                            {t.casas.leftText2}
                        </p>
                    </div>

                    <div className="casas-left-image">
                        <img src={amostra} alt="Estate detail" loading="lazy" />
                    </div>
                </div>

                <div className="casas-right-section">
                    <div className="casas-right-image">
                        <img src={fotodascasastodasquinta} alt="Villa estate overview" loading="lazy" />
                    </div>

                    <div className="casas-right-button">
                        <button
                            className="casas-view-gallery-btn"
                            onClick={handleExplore}
                            onMouseEnter={preloadVillaDetail}
                            onFocus={preloadVillaDetail}
                        >
                            <span>{t.casas.viewVillas}</span>
                            <div className="btn-circle">
                                <ArrowRight size={18} strokeWidth={1.5} />
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Casas;
